module.exports = __webpack_public_path__ + "img/fj.fjb565278.svg";